export default __webpack_public_path__ + "static/media/crossroadschapterspic.1cf7c3e9.png";